import { render, staticRenderFns } from "./TipoAtividadeSelect.vue?vue&type=template&id=1fb59f86"
import script from "./TipoAtividadeSelect.vue?vue&type=script&lang=js"
export * from "./TipoAtividadeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports